<template>
    <div>
        <b-modal id="status-keyword-popup" ref="modal" size="sm" no-close-on-backdrop no-close-on-esc
            modal-class="hide-footer" :hide-header-close="loading" hide-footer @hidden="onHidden">
            <div slot="modal-header" class="w-100 archive-popup">
                <h5 class="modal-title">{{ title }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onHidden">
                    <span aria-hidden="true">Ã—</span>
                </button>
            </div>
            <p class="custom-model-form custom-risk-override">
                {{ description }}
            </p>
            <div class="col-md-12 action-buttons">
                <button :class="['btn btn-primary', { disabled: loading }]" type="submit" @click="
                $emit('updateStatus', {
                    type: 'status',
                    status: status,
                })
                ">
                    <span class="btn-text">{{ title }}</span>
                    <span class="loader"></span>
                </button>
                <button class="btn btn-link" type="button" @click="onHidden">
                    <span class="btn-text">Cancel</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {}, //
    watch: {
        hidePopup(val) {
            if (val) {
                this.onHidden()
            }
        },
    },
    computed: {
        ...mapGetters(['loading', 'hidePopup', 'selectedItem']),
        title() {
            let status = 'archived'
            if (this.status == 'archived') {
                status = 'Archive'
            }
            return status
        },
        description() {
            let name = 'this'
            if (this.selectedItem && this.selectedItem.title) {
                name = this.selectedItem.title
            }
            let status = 'archived'
            if (this.status == 'archived') {
                status = 'archive'
            }
            return `Are you sure you want to ${status} ${name}?`

            return `Are you sure you want to ${this.status} ${name}`
        },
        status() {
            let status = 'active'
            if (this.selectedItem && this.selectedItem.status == 'active') {
                status = 'archived'
            }
            return status
        },
    },
    data() {
        return {}
    },
    methods: {
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>